import { TableHeaderProps } from '@components/table/types'
import styled from '@emotion/styled'
import Status from '@components/status'

export const columns: TableHeaderProps[] = [
  {
    title: 'Match ID',
    key: 'matchId',
  },
  {
    title: 'Created By',
    key: 'createdBy',
    render: (item) => (
      <CreatedByWrapper>
        <ProfilePreview>
          {item.createdBy.name?.toLowerCase() === 'admin' ? (
            <span style={{ color: 'white', fontSize: '20px' }}>A</span>
          ) : (
            <img
              src={`https://admin.tournaop.com/${item?.user?.avatar}`}
              alt="user avatar"
              style={{ width: '100%', borderRadius: '100vh' }}
            />
          )}
        </ProfilePreview>
        <UserDetails>
          <Name>{item?.createdBy?.name}</Name>
        </UserDetails>
      </CreatedByWrapper>
    ),
  },
  {
    title: 'Matchroom Name',
    key: 'matchRoomName',
    render: (item) => <span>{item.matchRoomName}</span>,
  },
  {
    title: 'Game Name',
    key: 'gameName',
    render: (item) => <span>{item.gameName}</span>,
  },
  {
    title: 'Match Type',
    key: 'matchType',
    render: (item) => <span>{item.matchType}</span>,
  },
  {
    title: 'Match Time',
    key: 'matchTime',
    render: (item) => (
      <MatchDateTimeWrapper>
        <p>{item.matchTime.date}</p>
        <p>{item.matchTime.time}</p>
      </MatchDateTimeWrapper>
    ),
  },
  {
    title: 'Status',
    key: 'status',
    render: (item) => {
      return <Status item={item} />
    },
  },
]

const CreatedByWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
`

const ProfilePreview = styled.div`
  width: 50px;
  height: 50px;
  background-color: #9395e9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 2px;
`
const Name = styled.p`
  color: ${(props: any) => props.theme.colors.text};
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
`
const Number = styled.p`
  color: ${(props: any) => props.theme.colors.text50};
  letter-spacing: 0.25px;
  line-height: 20px;
`

const MatchDateTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
  line-height: 1.4;
`

export const recentUsersColumn = [
  {
    title: 'Username',
    key: 'username',
    render: (item: any) => <>{item.name}</>,
  },
  {
    title: 'Mobile Number',
    key: 'mobileNumber',
    render: (item: any) => <>{item.phoneNo}</>,
  },
  {
    title: 'Email',
    key: 'email',
    render: (item: any) => <>{item.email}</>,
  },
]

export const recentProvidersColumn = [
  {
    title: 'Provider Name',
    key: 'providerName',
    render: (item) => item.name,
  },
  {
    title: 'Mobile Number',
    key: 'mobileNumber',
    render: (item: any) => <>{item.phoneNo}</>,
  },
  {
    title: 'Organization Name',
    key: 'organizationName',
    render: (item: any) => (
      <>{item?.infos?.companyInfos?.companyName || 'N/A'}</>
    ),
  },
]
